import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const AuthStateContext = createContext(null);
export const AuthUpdateContext = createContext(null);

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return JSON.parse(c.substring(name.length, c.length));
    }
  }
  return null;
}

const existingUser = getCookie("user");

export function AuthProvider({ children }) {
  const [activeUser, setActiveUser] = useState(existingUser);
  const isEditor = activeUser?.user_permission <= 2 || false;
  const state = { activeUser, isEditor };
  const updateFns = { setActiveUser };
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!activeUser) {
      navigate("/login");
    }
    if (activeUser && pathname.includes("/login")) {
      navigate("/");
    }
  }, [pathname]);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthUpdateContext.Provider value={updateFns}>
        {children}
      </AuthUpdateContext.Provider>
    </AuthStateContext.Provider>
  );
}

export function useAuth() {
  const state = useContext(AuthStateContext);
  const updateFns = useContext(AuthUpdateContext);
  return [state, updateFns];
}
